











import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryUserChannelList, DeleteUserChannel } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import constant from '@/utils/constant'
import CreateChannelDialog from './CreateChannelDialog.vue'
import UpdateChannelDialog from './UpdateChannelDialog.vue'
import { MessageBox , Message} from 'element-ui'

@Component({
  components: {
    VQuery,
    VTable,
    CreateChannelDialog,
    UpdateChannelDialog,
  },
})
export default class PlatformManager extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '渠道编号', param: 'channelNo' },
    { title: '渠道名称', param: 'channelName' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    {
      title: '创建渠道',
      type: 'primary',
      click: () => {
        this.openDialog('CreateChannelDialog')
      },
    },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '渠道编号', param: 'channelNo' },
    { title: '渠道名称', param: 'channelName' },
    { title: '渠道链接(小程序)', param: 'channelNo', formatter: this.channelUrl },
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    {
      title: '操作',
      operation: [
        {
          title: '修改',
          icon: 'el-icon-edit',
          click: (data) => this.openDialog('UpdateChannelDialog', data),
        },
        {
          title: '删除',
          icon: 'el-icon-delete',
          style: { color: '#ff0000' },
          click:  this.deleteRow
        },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private channelUrl(channel: string) {
    return 'https://XXXXXX待定?channel=' + channel
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryUserChannelList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private openDialog(dia: string, data?: any) {
    const f = this.$refs[dia] as any
    f.open(data)
  }
  // 删除单行数据
  public deleteRow(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteUserChannel({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
}
